export const isLatitude = (num: number) => isFinite(num) && Math.abs(num) <= 90;

export const isLongitude = (num: number) =>
    isFinite(num) && Math.abs(num) <= 180;
